import React, { useRef, useState, useEffect, Fragment } from 'react';
import { Modal, Table } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import Loader from 'react-loader-spinner';
import { X } from "react-bootstrap-icons";
import { Accordion, Card } from 'react-bootstrap';
import { getActiveUnusedGuaranteeCards, getSerialHistory } from "../store/api/ServiceAPI";
import { convertChar, toEnglishNumber } from '../../store/api/ConvertToEnglish';
import { setSerialHistoryPopup } from '../store/api/Modals';
import BihamtaTable from '../../Components/BihamtaTable';


const ModalSerialHistory = (props) => {

    const pop = useSelector(state => state.popup.serialHistoryPop);
    const { serialHistory, activeUnusedCards } = useSelector(state => { return { serialHistory: state.service.serialHistory, activeUnusedCards: state.service.activeUnusedCards } });

    const searchData = useRef({});
    const searchCardData = useRef({});
    const dispatch = useDispatch();
    const [width, setWidth] = useState(window.innerWidth);
    const tableCols = [
        { colName: "RowNumber", colTitle: "شماره ردیف", showInMobile: true },
        { colName: "POperatorType", colTitle: "", showInMobile: true },
        { colName: "PHistoryDate", colTitle: "", showInMobile: true },
        { colName: "OperatorNumber", colTitle: "", showInMobile: true },
        { colName: "ProductName", colTitle: "" },
        { colName: "ProductModel", colTitle: "" },
        { colName: "SerialNumber", colTitle: "" },
    ]
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);
    const handleModal = () => {
        dispatch(setSerialHistoryPopup({ show: false }));
    }
    const onChangeSearchData = (value, type) => {
        if (type === "G_CardNo") {
            searchCardData.current.CardNo = value;
        }
        else if (type === "G_Serial") {
            searchCardData.current.Serial = value;
        }
        else if (type === "SH_CardNo") {
            searchData.current.CardNo = value;
        }
        else if (type === "SH_Serial") {
            searchData.current.Serial = value;
        }
    }
    const searchHistory = () => {

        if ((!searchData.current.CardNo || searchData.current.CardNo === '') && (!searchData.current.Serial || searchData.current.Serial === '')) {
            alert('هیچکدام از کادرهای جستجو پر نشده است');
            return;
        }
        dispatch(getSerialHistory(searchData.current.Serial, searchData.current.CardNo, -1, -1));
    }
    const searchUnusedCards = () => {

        if ((!searchCardData.current.CardNo || searchCardData.current.CardNo === '') && (!searchCardData.current.Serial || searchCardData.current.Serial === '')) {
            alert('هیچکدام از کادرهای جستجو پر نشده است');
            return;
        }
        dispatch(getActiveUnusedGuaranteeCards(searchCardData.current.CardNo, searchCardData.current.Serial, 0, 5));
    }
    const select = (item) => {
        if (pop.onSetData) {
            if (item.RelatedProductID) {
                item.ProductID = item.RelatedProductID;
            }
            if (item.RelatedProductModel) {
                item.ProductModel = item.RelatedProductModel;
            }
            if (item.RelatedProductName) {
                item.ProductName = item.RelatedProductName;
            }
            const { e, target, ...itemCopy } = item;
            pop.onSetData(itemCopy);
        }
        dispatch(setSerialHistoryPopup({ show: false }));
    }
    return (
        <Modal size="lg" show={pop.show} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header style={{ backgroundColor: '#e40375' }}>تاریخچه سریال/گارانتی<span onClick={handleModal} style={{ cursor: "pointer" }}><X size={20} /></span></Modal.Header>
            <Modal.Body >
                <Accordion defaultActiveKey="1">
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="1" style={{ backgroundColor: "rgb(30 165 187)" }}>
                            جستجوی کارت گارانتی
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="1">
                            <Card.Body>
                                <div className="row">
                                    <div className="form-group">
                                        <input type="text" placeholder="شماره گارانتی" lang='en' className="form-control" id="G_CardNo"
                                            onChange={(e) => onChangeSearchData(e.target.value, "G_CardNo")} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />

                                    </div>
                                    <div className='form-group'>
                                        <input type="text" placeholder="شماره سریال" lang='en' className="form-control" id="G_Serial"
                                            onChange={(e) => onChangeSearchData(e.target.value, "G_Serial")} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />

                                    </div>
                                </div>
                                <button type="button" className="btn btn-primary w-100 mt-2" onClick={searchUnusedCards}>جستجو</button>
                                <br />
                                <br />
                                {activeUnusedCards && activeUnusedCards === "PENDING" &&
                                    <Loader style={{ textAlign: "center" }} type="BallTriangle" color="#bb1370" height={25} width={25} />
                                }
                                {activeUnusedCards && Array.isArray(activeUnusedCards) &&
                                    <Table responsive>
                                        <thead>
                                            <tr style={{ padding: "0" }}>
                                                {width > 414 &&
                                                    <Fragment>
                                                        <th>برند</th>
                                                        <th>شماره کارت</th>
                                                        <th>شماره سریال</th>
                                                    </Fragment>}
                                                <th>{width > 414 ? "نام و مدل محصول" : "محصول"}</th>
                                                <th>آغاز گارانتی</th>
                                                <th>پایان گارانتی</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {activeUnusedCards.map((item, i) => {
                                                return (
                                                    <tr className='resultTableRow' key={i} style={{ backgroundColor: i % 2 === 0 ? "white" : "#e9e9e9" }} onClick={() => select(item)}>
                                                        {width > 414 &&
                                                            <Fragment>
                                                                <td>{item?.HolderName}</td>
                                                                <td style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }}>{item?.GuaranteeCardNo}</td>
                                                                <td style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }}>{item?.SerialNumber}</td>
                                                            </Fragment>}
                                                        <td>{item?.RelatedProductName}-{item?.RelatedProductModel}</td>
                                                        <td>{item?.GuaranteeStartPersianDate}</td>
                                                        <td>{item?.GuaranteePersianEndDate}</td>
                                                    </tr>)
                                            })
                                            }
                                        </tbody>
                                    </Table>}
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                    <Card>
                        <Accordion.Toggle as={Card.Header} eventKey="0" style={{ backgroundColor: "rgb(30 165 187)" }}>
                            تاریخچه سریال
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <Card.Body>
                                <div className="row">
                                    <div className="form-group">
                                        <input type="text" placeholder="شماره گارانتی" lang='en' className="form-control" id="SH_CardNo" style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }}
                                            onChange={(e) => onChangeSearchData(e.target.value, "SH_CardNo")} />
                                    </div>
                                    <div className='form-group'>
                                        <input type="text" placeholder="شماره سریال" lang='en' className="form-control" id="SH_Serial" onKeyUp={(e) => toEnglishNumber(e)}
                                            style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} onChange={(e) => onChangeSearchData(e.target.value, "SH_Serial")} />
                                    </div>
                                </div>
                                <button type="button" className="btn btn-primary w-100 mt-2" onClick={searchHistory}>جستجو</button>
                                <br />
                                <br />
                                {serialHistory === "PENDING" &&
                                    <Loader style={{ textAlign: "center" }} type="BallTriangle" color="#bb1370" height={25} width={25} />
                                }
                                {/* {serialHistory && Array.isArray(serialHistory) &&
                                    <Table responsive>
                                        <thead>
                                            <tr style={{ padding: "0" }}>
                                                <th>{width > 414 ? "نام فرم" : "فرم"}</th>
                                                <th>تاریخ فرم</th>
                                                <th>{width > 414 ? 'شماره فرم' : 'ش.فرم'}</th>
                                                <th>نام کالا</th>
                                                {width > 414 &&
                                                    <Fragment>
                                                        <th>مدل کالا</th>
                                                        <th>شماره سریال</th>
                                                    </Fragment>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {serialHistory.map((item, i) => {
                                                return (
                                                    <tr className='resultTableRow' key={i} style={{ backgroundColor: i % 2 === 0 ? "white" : "#e9e9e9" }} onClick={() => select(item)}>
                                                        <td>{item.POperatorType}</td>
                                                        <td>{item.PHistoryDate}</td>
                                                        <td>{item.OperatorNumber}</td>
                                                        <td>{item.ProductName}</td>
                                                        {width > 414 &&
                                                            <Fragment>
                                                                <td>{item.ProductModel}</td>
                                                                <td>{item.SerialNumber}</td>
                                                            </Fragment>}
                                                    </tr>)
                                            })
                                            }
                                        </tbody>
                                    </Table>} */}
                                <BihamtaTable columns={tableCols} dataList={{ Data: serialHistory }} maxHeight={350} rowClick={select} />
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
            </Modal.Body>
            <Modal.Footer style={{ justifyContent: "flex-start" }}>
            </Modal.Footer>
        </Modal >
    )
}
export default ModalSerialHistory;